import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
// import Pagination from "react-js-pagination";
import AxiosInstance from "../../helper/AxiosInstance";

function Blog() {
   const { slug } = useParams()
   const [request, setRequest] = useState({ categorieId: '', active: 1, total: 0, limit: 9 })
   const [response, setResponse] = useState({ loader: false })
   const [blogs, setBlogs] = useState([])
   const [categories, setCategories] = useState([])
   const [recenetBlog, setRecenetBlog] = useState([])
   const getData = async () => {
      try {
         setResponse((prev) => ({ ...prev, loader: true }))
         const response = await AxiosInstance.get(`/blog/public/blogs?categorieSlug=${slug || ''}`);
         if (response.status == 1) {
            setRequest((prev) => ({ ...prev, active: 1, total: response.data.length }))
            setCategories(response.categories)
            setBlogs(response.data);
            setRecenetBlog(response.recentBlog)
         } else {
            setBlogs([])
         }
      } catch (err) { } finally {
         setResponse((prev) => ({ ...prev, loader: false }))
      }
   }
   useEffect(() => {slug? window.scrollTo(0, 600) : window.scrollTo(0, 0); getData() }, [slug]);
   return (
      <>

         <Helmet>
            <title>Blog | Taskflier | A Trusted Platform for Outsourcing Project </title>
         </Helmet>



            <div class="fancy-hero-five " style={{'padding':" 65px 0"}}>
				<img src="images/shape/95.svg" alt="" class="shapes shape-one"/>
				<img src="images/shape/96.svg" alt="" class="shapes shape-two"/>
				<div class="bg-wrapper">
					<div class="container">
						<div class="row">
							<div class="col-lg-7 m-auto text-center">
                    
                     <span class="upper-title custom-name">Blog</span>
                     <h3 class="maintitle">Explore ideas, tips, and stories that inspire, inform, and spark your curiosity every day.</h3>
                     <p className="mainp">The Latest Industry News, Interviews, Technologies and Resources</p>
							</div>
						</div>
					</div>
				</div> 
			</div>
            <div class="feature-blog-one blogs bg-white">
               <div class="shapes shape-one"></div>
               <div class="shapes shape-two"></div>
               <div class="shapes shape-three"></div>
               <div class="container  bloginner">
                 
                     <div class="row">
                        {
                           response.loader ?
                              <>
                                 <div class="col-lg-4 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200">
                                    <div class="post-meta placeholder-glow">
                                       <img src="" alt="" class="image-meta" />
                                       <div class="tag text-capitalize"><span class="placeholder col-7"></span></div>
                                       <p class="card-text placeholder-glow">
                                          <span class="placeholder col-7"></span>
                                          <span class="placeholder col-4"></span>
                                       </p>
                                       <a class="read-more d-flex justify-content-between align-items-center">
                                          <span class="placeholder col-4"></span>
                                       </a>
                                    </div>
                                 </div>
                                 <div class="col-lg-4 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200">
                                    <div class="post-meta placeholder-glow">
                                       <img src="" alt="" class="image-meta" />
                                       <div class="tag text-capitalize"><span class="placeholder col-7"></span></div>
                                       <p class="card-text placeholder-glow">
                                          <span class="placeholder col-7"></span>
                                          <span class="placeholder col-4"></span>
                                       </p>
                                       <a class="read-more d-flex justify-content-between align-items-center">
                                          <span class="placeholder col-4"></span>
                                       </a>
                                    </div>
                                 </div>
                                 <div class="col-lg-4 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200">
                                    <div class="post-meta placeholder-glow">
                                       <img src="" alt="" class="image-meta" />
                                       <div class="tag text-capitalize"><span class="placeholder col-7"></span></div>
                                       <p class="card-text placeholder-glow">
                                          <span class="placeholder col-7"></span>
                                          <span class="placeholder col-4"></span>
                                       </p>
                                       <a class="read-more d-flex justify-content-between align-items-center">
                                          <span class="placeholder col-4"></span>
                                       </a>
                                    </div>
                                 </div>
                                 </>
                             
                              :
                              <>
                                 {
                                    !blogs || blogs.length==0?
                                    <div className="text-center mb-4">
                                       <img src="/files/noData.png" className="m-auto"/>
                                    </div>
                                    :
                                    blogs.map((itm, ind) => {                                       
                                       if ((request.active - 1) * request.limit <= ind && ind < (request.active * request.limit)) {
                                          return (<div class="col-lg-4 col-md-4 col-sm-4 d-block aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200">
                                             <div key={itm._id} class="post-meta">
                                                <img src={itm.image} alt="" class="image-meta" />
                                                {/* <img src={`https://taskflier.com/tenants/super/blogs/${itm.image}`} alt="" class="image-meta" /> */}
                                               
                                                <div className="d-flex justify-content-between align-items-center blog-header "> <span class=" text-capitalize">{itm.categorie}</span> <span className="read"><i class="bi bi-stopwatch"></i> Max {itm.readTime} read</span></div> 

                                                <h1><Link to={`/blog/${itm.slug}`} class="title text-capitalize">{itm.title.length > 60 ? itm.title.slice(0, 60) + "..." : itm.title}</Link></h1>
                                                <Link to={`/blog/${itm.slug}`} class="read-more d-flex justify-content-between align-items-center">
                                                   <span>Read More</span>
                                                   <i class="flaticon-right-arrow"></i>
                                                </Link>
                                             </div>

                                          </div>)
                                       }
                                    })
                                 }
                             </>
                        }
                         </div>

                  
                     <div className="col-md-3" hidden>
                        <div class="blog-sidebar-one">
                           <div class="sidebar-categories mb-85">
                              <h4 class="sidebar-title">Categories</h4>
                              <ul>
                                 {
                                    categories.map((cate) => {
                                       return (<li className="text-capitalize"><Link to={`/blog/categorie/${cate.slug}`}>{cate.name} <span>({(cate.blogs).toString().padStart(2, '0')})</span></Link></li>)
                                    })
                                 }
                              </ul>
                           </div>
                           <div class="sidebar-recent-news mb-85">
                              <h4 class="sidebar-title">Recent Blog</h4>
                              <ul>
                                 {
                                    recenetBlog.map((rec) => {
                                       return (<li>
                                          <Link to={`/blog/${rec.slug}`}>
                                             <span class="title">{rec.title.length > 60 ? rec.title.slice(0, 60) + "..." : rec.title}</span>
                                             <span class="date">{new Date(rec.createdAt).toUTCString().slice(5, 16)}</span>
                                          </Link>
                                       </li>)
                                    })
                                 }
                              </ul>
                           </div>
                        </div>
                    
                  </div>
                  {/* <Pagination
                     activePage={request.active}
                     totalItemsCount={request.total}
                     itemsCountPerPage={request.limit}
                     onChange={(e) => { setRequest((prev) => ({ ...prev, active: e })) }}
                     innerClass="pagination justify-content-center small mb-0"
                     itemClass="page-item"
                     linkClass="page-link"
                     activeLinkClass="active"
                     firstPageText="First"
                     lastPageText="Last"
                  /> */}
               </div>
            </div>
      </>
   );
}

export default Blog;